module.exports = __webpack_public_path__ + "media/images/emprelatam-logo-transparente-b890934f.png";